import React, { useState } from 'react';
import InputField from '../InputField';
import { Button, Divider, Modal, showToast, StyleProvider } from '@attentive-platform/stem-ui';
import { fetchApiData, interpolate } from '../../Utils/ApiCalls';
import { PORTFOLIO_EXECUTE } from '../../urls';
import { PORTFOLIO_REVIEW_ENUM } from '../../Constants/Constants';

const FalconUserAssignModal = ({ show, setShow, refetchData, portfolioId, selectedRows }) => {
  const [emailId, setEmailId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEmailChange = (key, value) => {
    setEmailId(value);
  };

  const validateEmail = email => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleFalconSubmit = async () => {
    if (!validateEmail(emailId)) {
      setError('Invalid email address');
      return;
    }
    setError('');
    setLoading(true);

    try {
      await fetchApiData({
        endpoint: interpolate(PORTFOLIO_EXECUTE, [portfolioId]),
        apiRequest: 'POST',
        data: {
          execute_on: PORTFOLIO_REVIEW_ENUM.FALCON,
          user_email: emailId.toLowerCase(),
          ...(selectedRows && { selected_rows: selectedRows })
        }
      });
      showToast('Portfolio review for Falcon started successfully', 'success');
      await refetchData();
    } catch (error) {
      showToast(error, 'error');
      return;
    } finally {
      setEmailId('');
      setLoading(false);
      setShow(false);
    }
  };

  return (
    <Modal
      show={show}
      heading={<span className='pl-4'>Enter email of user</span>}
      onClose={() => setShow(false)}
      content={
        <div className='flex flex-col gap-2 m-4 w-[500px]'>
          <StyleProvider theme='attentive-internal'>
            <InputField
              color='secondary'
              label='Email Id'
              type='text'
              placeholder='Enter Email Id'
              value={emailId}
              onChange={handleEmailChange}
              error={error}
              extraProps={{
                className: 'w-full'
              }}
            />
          </StyleProvider>
          <Divider />
          <div className='flex justify-end gap-2'>
            <Button size='medium' variant='outlined' color='secondary' onClick={() => setShow(false)}>
              Cancel
            </Button>
            <Button loading={loading} size='medium' color='secondary' onClick={handleFalconSubmit}>
              Execute
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default FalconUserAssignModal;
